import React, { useEffect, useState, Fragment } from 'react';
import { paginate, Pagination, PageHeader } from '../../../Common';
import { TableContent, TableContentUserList } from '../../Common/Table/tableContent';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';

import services from '../services';
import { TableCard } from '../../Common'
import $ from 'jquery';


export function UserListing({ userData, handleClick, handleReset}) {

    const [allUsers, setAllUsers] = useState([])
    const [user, setUser] = useState([]);

    const contentRowNames = ["userName", "email", "firstName", "lastName", "userRoleName", "isActive", "isLocked"]

    useEffect(() => {
        trackPromise(
            setUserData()
        )
    }, [userData]);

    async function setUserData() {
        destroyDataTable();
        await setAllUsers(userData);
        createDataTable();
    }

    function destroyDataTable(){
        $('#example').DataTable().destroy();
    }

    function createDataTable(){
        $('#example').DataTable();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div>
                        <div>
                            <div className="table-responsive row-top-gap">
                                <table id="example" className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Username</th>
                                            <th>Email</th>
                                            <th>First Name</th>
                                            <th>Last Name</th>
                                            <th>User Role</th>
                                            <th>Status</th>
                                            <th>Locked</th>
                                            <th>Actions</th>
                                            <th>Reset</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContentUserList
                                            data={allUsers}
                                            contentRowNames={contentRowNames}
                                            handleClick={handleClick}
                                            handleReset={handleReset}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


